import { RiGithubFill, RiTwitterFill } from 'react-icons/ri';

export const socials = [
  { name: 'GitHub', href: 'https://github.com/stablocks/stablocks', icon: RiGithubFill },
  { name: 'Twitter', href: 'https://twitter.com/stablocks', icon: RiTwitterFill },
]